// extracted by mini-css-extract-plugin
module.exports = {"layout":"ChangePasswordPopup__layout--RUQ","container":"ChangePasswordPopup__container--CHI"};